import { OfbizList, OfbizForm } from "@urbannex/ofbiz-forms";
import { ConfigOptions, CustomContainerItem, StoreEditContainerComponent, getColumnFieldTitles, getFieldSets, getFields, getTarget, getTargets } from "@urbannex/view-containers";
import { STR_FORMS } from "./forms";

export const options: ConfigOptions = {
    name: "Product Store Application",
    title: "Product Store",
    menuAndTitleOptions: {
        path: "stores",
        headerTitle: "Product Store Application",
        menuItems: [],
        menuTag: "storesMenu"
    },
    listForm: new OfbizList({
        listFormName: "ListProductStore",
        listFormLocation: "component://kwikstore/widget/StoreForms.xml",
        listType: "grid",
        columnFields: getFields("ListProductStore", STR_FORMS),
        columnFieldTitles: getColumnFieldTitles("ListProductStore", STR_FORMS),
        appContext: "catalog",
        emptyListMessage: "No product stores available.",
        remoteFormData: {
            formData: {
                formName: "ListProductStore",
                formLocation: "component://kwikstore/widget/StoreForms.xml",
                listType: "grid",
                viewIndex: 1,
            },
            appContext: "catalog",
            parameters: { "noConditionFind": "Y" }
        },
    }),
    addForm: new OfbizForm({
        formName: "EditProductStore",
        local: true,
        formLocation: "component://kwikstore/widget/StoreForms.xml",
        appContext: "catalog",
        fields: getFields("EditProductStore", STR_FORMS),
        fieldSets: getFieldSets("EditProductStore", STR_FORMS),
        target: getTarget("EditProductStore", STR_FORMS),
        targets: getTargets("EditProductStore", STR_FORMS),
        titleDescriptionField: "storeName",
        idFieldName: "productStoreId",
        renderComponent: "EditStore"
    }),
    findForm: undefined,
    breadCrumbData: {
        displayPrefix: "Stores",
        label: "",
        level: 1,
        selectedValue: {
            event: "list",
            type: "ListProductStore",
            data: {
                formData: {
                    formName: "ListProductStore",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                }
            }
        },
        addFormText: "Create New Product Store",
        editFormText: "Edit Product Store"
    },
    relations: [{
        title: "Roles",
        addContainerTitle: "Add Store Role",
        listContainerTitle: "Store Roles",
        addFormName: "EditProductStoreRole",
        listFormName: "ListProductStoreRole",
        addForm: new OfbizForm({
            formName: "EditProductStoreRole",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            local: true,
            fields: getFields("EditProductStoreRole", STR_FORMS),
            appContext: "catalog",
            target: getTarget("EditProductStoreRole", STR_FORMS) || null,
            targets: getTargets("EditProductStoreRole", STR_FORMS) || null,
        }),
        listForm: new OfbizList({
            listFormName: "ListProductStoreRole",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            columnFields: getFields("ListProductStoreRole", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("ListProductStoreRole", STR_FORMS),
            appContext: "catalog",
            listType: "grid",
            emptyListMessage: "No roles defined for this store",
            remoteFormData: {
                formData: {
                    formName: "ListProductStoreRole",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" }
    }, {
        title: "Store Promotions",
        addContainerTitle: "Add Promotion",
        listContainerTitle: "Store Promotions",
        addFormName: "CreateProductStorePromo",
        listFormName: "ListProductStorePromos",
        addForm: new OfbizForm({
            formName: "CreateProductStorePromo",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            fields: getFields("CreateProductStorePromo", STR_FORMS),
            appContext: "catalog",
            target: getTarget("CreateProductStorePromo", STR_FORMS) || null,
            targets: getTargets("CreateProductStorePromo", STR_FORMS),
        }),
        listForm: new OfbizList({
            listFormName: "ListProductStorePromos",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            listType: "grid",
            columnFields: getFields("ListProductStorePromos", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("ListProductStorePromos", STR_FORMS),
            emptyListMessage: "No promotions listed for this store",
            appContext: "catalog",
            remoteFormData: {
                formData: {
                    formName: "ListProductStorePromos",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" }
    }, {
        title: "Catalogs",
        addContainerTitle: "Add Store Catalog",
        addFormName: "CreateProductStoreCatalog",
        addForm: new OfbizForm({
            formName: "CreateProductStoreCatalog",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            fields: getFields("CreateProductStoreCatalog", STR_FORMS),
            appContext: "catalog",
            target: getTarget("CreateProductStoreCatalog", STR_FORMS) || null,
            targets: getTargets("CreateProductStoreCatalog", STR_FORMS) || null,
        }),
        listContainerTitle: "Store Catalogs",
        listFormName: "UpdateProductStoreCatalog",
        listForm: new OfbizList({
            listFormName: "UpdateProductStoreCatalog",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            listType: "grid",
            emptyListMessage: "No catalogs listed for this store",
            appContext: "catalog",
            columnFields: getFields("UpdateProductStoreCatalog", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("UpdateProductStoreCatalog", STR_FORMS),
            remoteFormData: {
                formData: {
                    formName: "UpdateProductStoreCatalog",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" },
    }, {
        title: "Web Sites",
        addContainerTitle: "Add web site to this store",
        addFormName: "SetProductStoreOnWebSite",
        addForm: new OfbizForm({
            formName: "SetProductStoreOnWebSite",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            fields: getFields("SetProductStoreOnWebSite", STR_FORMS),
            appContext: "catalog",
            targets: getTargets("SetProductStoreOnWebSite", STR_FORMS) || null,
            target: getTarget("SetProductStoreOnWebSite", STR_FORMS) || null,
        }),
        listContainerTitle: "Web sites for this store",
        listFormName: "EditProductStoreWebSites",
        listForm: new OfbizList({
            listFormName: "EditProductStoreWebSites",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            listType: "grid",
            columnFields: getFields("EditProductStoreWebSites", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("EditProductStoreWebSites", STR_FORMS),
            appContext: "catalog",
            emptyListMessage: "No web sites listed for this store",
            remoteFormData: {
                formData: {
                    formName: "EditProductStoreWebSites",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" }
    }, {
        title: "Shipment Methods",
        addContainerTitle: "Add Product Store Shipment Method",
        addFormName: "EditProductStoreShipmentMeth",
        addForm: new OfbizForm({
            formName: "EditProductStoreShipmentMeth",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            fields: getFields("EditProductStoreShipmentMeth", STR_FORMS),
            appContext: "catalog",
            layout: "single",
            target: getTarget("EditProductStoreShipmentMeth", STR_FORMS) || null,
            targets: getTargets("EditProductStoreShipmentMeth", STR_FORMS) || null,
        }),
        listContainerTitle: "Shipment Methods",
        listFormName: "ListProductStoreShipmentMeths",
        listForm: new OfbizList({
            listFormName: "ListProductStoreShipmentMeths",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            listType: "grid",
            emptyListMessage: "No shipment methods for this store",
            appContext: "catalog",
            columnFields: getFields("ListProductStoreShipmentMeths", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("ListProductStoreShipmentMeths", STR_FORMS),
            remoteFormData: {
                formData: {
                    formName: "ListProductStoreShipmentMeths",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" }
    }, {
        title: "Shipment Cost Estimates",
        addContainerTitle: "Add Shipment Cost Estimate",
        addFormName: "AddShipmentCostEstimate",
        addForm: new OfbizForm({
            formName: "AddShipmentCostEstimate",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            fields: getFields("AddShipmentCostEstimate", STR_FORMS),
            appContext: "catalog",
            target: getTarget("AddShipmentCostEstimate", STR_FORMS) || null,
            targets: getTargets("AddShipmentCostEstimate", STR_FORMS) || null,
        }),
        listContainerTitle: "Shipment Cost Estimates",
        listFormName: "ListShipmentCostEstimates",
        listForm: new OfbizList({
            listFormName: "ListShipmentCostEstimates",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            listType: "grid",
            appContext: "catalog",
            columnFields: getFields("ListShipmentCostEstimates", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("ListShipmentCostEstimates", STR_FORMS),
            emptyListMessage: "No shipment cost estimates for this store",
            remoteFormData: {
                formData: {
                    formName: "ListShipmentCostEstimates",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" }
    }, {
        title: "Payment Settings",
        addContainerTitle: "Add New Payment Method",
        addFormName: "EditProductStorePaymentSetting",
        addForm: new OfbizForm({
            formName: "EditProductStorePaymentSetting",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            fields: getFields("EditProductStorePaymentSetting", STR_FORMS),
            targets: getTargets("EditProductStorePaymentSetting", STR_FORMS) || null,
            target: getTarget("EditProductStorePaymentSetting", STR_FORMS) || null,
            appContext: "catalog"
        }),
        listContainerTitle: "Product Store PaymentSettings",
        listFormName: "ListProductStorePaymentSettings",
        listForm: new OfbizList({
            listFormName: "ListProductStorePaymentSettings",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            listType: "grid",
            appContext: "catalog",
            columnFields: getFields("ListProductStorePaymentSettings", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("ListProductStorePaymentSettings", STR_FORMS),
            emptyListMessage: "No payment settings for this store",
            remoteFormData: {
                formData: {
                    formName: "ListProductStorePaymentSettings",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" }
    }, {
        title: "Financial Account Settings",
        addContainerTitle: "",
        addFormName: "EditProductStoreFinAccountSettings",
        addForm: new OfbizForm({
            formName: "EditProductStoreFinAccountSettings",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            fields: getFields("EditProductStoreFinAccountSettings", STR_FORMS),
            appContext: "catalog",
            targets: getTargets("EditProductStoreFinAccountSettings", STR_FORMS) || null,
            target: getTarget("EditProductStoreFinAccountSettings", STR_FORMS) || null,
        }),
        listContainerTitle: "",
        listFormName: "ListProductStoreFinAccountSettings",
        listForm: new OfbizList({
            listFormName: "ListProductStoreFinAccountSettings",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            appContext: "catalog",
            emptyListMessage: "No financial account setting for this store",
            columnFields: getFields("ListProductStoreFinAccountSettings", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("ListProductStoreFinAccountSettings", STR_FORMS),
            remoteFormData: {
                formData: {
                    formName: "ListProductStoreFinAccountSettings",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" }
    }, {
        title: "Facilities",
        addContainerTitle: "Add Store Facility",
        addFormName: "EditProductStoreFacility",
        addForm: new OfbizForm({
            formName: "EditProductStoreFacility",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            fields: getFields("EditProductStoreFacility", STR_FORMS),
            appContext: "catalog",
            targets: getTargets("EditProductStoreFacility", STR_FORMS),
            target: getTarget("EditProductStoreFacility", STR_FORMS)
        }),
        listContainerTitle: "Store Facilities",
        listFormName: "ListProductStoreFacility",
        listForm: new OfbizList({
            listFormName: "ListProductStoreFacility",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            listType: 'grid',
            appContext: "catalog",
            columnFields: getFields("ListProductStoreFacility", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("ListProductStoreFacility", STR_FORMS),
            emptyListMessage: "No facilities for this store",
            remoteFormData: {
                formData: {
                    formName: "ListProductStoreFacility",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" }
    }, {
        title: "Store Email Settings",
        addContainerTitle: "Add Email Setting",
        addFormName: "CreateProductStoreEmail",
        addForm: new OfbizForm({
            formName: "CreateProductStoreEmail",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            fields: getFields("CreateProductStoreEmail", STR_FORMS),
            targets: getTargets("CreateProductStoreEmail", STR_FORMS) || null,
            target: getTarget("CreateProductStoreEmail", STR_FORMS) || null,
            appContext: "catalog"
        }),
        listContainerTitle: "Email Settings",
        listFormName: "UpdateProductStoreEmail",
        listForm: new OfbizList({
            listFormName: "UpdateProductStoreEmail",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            listType: "grid",
            columnFields: getFields("UpdateProductStoreEmail", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("UpdateProductStoreEmail", STR_FORMS),
            appContext: "catalog",
            emptyListMessage: "No email settings for this store",
            remoteFormData: {
                formData: {
                    formName: "UpdateProductStoreEmail",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" }
    }, {
        title: "Store Surveys",
        addContainerTitle: "Add Product Store Survey",
        addFormName: "AddProductStoreSurveys",
        addForm: new OfbizForm({
            formName: "AddProductStoreSurveys",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            appContext: "catalog",
            fields: getFields("AddProductStoreSurveys", STR_FORMS),
            targets: getTargets("AddProductStoreSurveys", STR_FORMS),
            target: getTarget("AddProductStoreSurveys", STR_FORMS)
        }),
        listContainerTitle: "Product Store Surveys",
        listFormName: "EditProductStoreSurveys",
        listForm: new OfbizList({
            listFormName: "EditProductStoreSurveys",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            listType: "grid",
            columnFields: getFields("EditProductStoreSurveys", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("EditProductStoreSurveys", STR_FORMS),
            appContext: "catalog",
            emptyListMessage: "No surveys listed for this store",
            remoteFormData: {
                formData: {
                    formName: "EditProductStoreSurveys",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" }
    }, {
        title: "Vendor Payment Settings",
        addContainerTitle: "Add Vendor Payment Setting",
        addFormName: "EditProductStoreVendorPayment",
        addForm: new OfbizForm({
            formName: "EditProductStoreVendorPayment",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            appContext: "catalog",
            fields: getFields("EditProductStoreVendorPayment", STR_FORMS),
            targets: getTargets("EditProductStoreVendorPayment", STR_FORMS) || null,
            target: getTarget("EditProductStoreVendorPayment", STR_FORMS) || null,
        }),
        listContainerTitle: "Vendor Payment Settings",
        listFormName: "ListProductStoreVendorPayments",
        listForm: new OfbizList({
            listFormName: "ListProductStoreVendorPayments",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            listType: "grid",
            columnFields: getFields("ListProductStoreVendorPayments", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("ListProductStoreVendorPayments", STR_FORMS),
            emptyListMessage: "No vendor payment settings for this store",
            appContext: "catalog",
            remoteFormData: {
                formData: {
                    formName: "ListProductStoreVendorPayments",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" }
    }, {
        title: "Vendor Shipments",
        addContainerTitle: "Add Vendor Shipment",
        addFormName: "EditProductStoreVendorShipment",
        addForm: new OfbizForm({
            formName: "EditProductStoreVendorShipment",
            formLocation: "component://kwikstore/widget/StoreForms.xml",
            appContext: "catalog",
            fields: getFields("EditProductStoreVendorShipment", STR_FORMS),
            targets: getTargets("EditProductStoreVendorShipment", STR_FORMS) || null,
            target: getTarget("EditProductStoreVendorShipment", STR_FORMS) || null,
        }),
        listContainerTitle: "Vendor Shipments",
        listFormName: "ListProductStoreVendorShipments",
        listForm: new OfbizList({
            listFormName: "ListProductStoreVendorShipments",
            listFormLocation: "component://kwikstore/widget/StoreForms.xml",
            listType: "grid",
            columnFields: getFields("ListProductStoreVendorShipments", STR_FORMS),
            columnFieldTitles: getColumnFieldTitles("ListProductStoreVendorShipments", STR_FORMS),
            appContext: "catalog",
            emptyListMessage: "No vendor shipments",
            remoteFormData: {
                formData: {
                    formName: "ListProductStoreVendorShipments",
                    formLocation: "component://kwikstore/widget/StoreForms.xml",
                    listType: "grid",
                    viewIndex: 1,
                },
                appContext: "catalog",
                parameters: { "productStoreId": "" }
            }
        }),
        keyMap: { "fieldName": "productStoreId" }
    }],
    customContainerItems: [new CustomContainerItem("EditStore", StoreEditContainerComponent, {})],
    actions: [],
    settings: [],
    assistant: {
        enabled: false,
        name: "Store Configuration Assistant",
        path: "stores/store",
        capabilities: [
            {
                type: "store",
                description: "Hi, I am your friendly store configuration assistant.  I can help you set up your store.",
                requiredFields: [],
                contextualHint: ""
            }
        ],
        contextualTriggers: {
            onCreate: true
        },
        defaultPrompts: {
            key: "Give a short description of your store including it's name"
        },
        uiPosition: 'sidebar',
        serverEndpoints: {
            "store": "/api/store"
        }
    }
};
